export default "__VITE_ASSET__DvHxLd_Y__"